// resources/js/frontend/router/index.js
import { createRouter, createWebHistory } from "vue-router";

import NotFound from "@/frontend/pages/NotFound.vue";
import Home from "@/frontend/pages/Home.vue";
import Search from "@/frontend/pages/Search.vue";
import Faqs from "@/frontend/pages/Faqs.vue";
import HowToPackShip from "@/frontend/pages/HowToPackShip.vue";
import SignUp from "@/frontend/pages/SignUp.vue";
import Terms from "@/frontend/pages/Terms.vue";
import Privacy from "@/frontend/pages/Privacy.vue";
import CollectionEstimate from "@/frontend/pages/CollectionEstimate.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      children: [{ path: "/", name: "Home", component: Home }],
    },
    {
      path: "/search",
      children: [{ path: "/search", name: "Search", component: Search }],
    },
    {
      path: "/faqs",
      children: [{ path: "/faqs", name: "Faqs", component: Faqs }],
    },
    {
      path: "/how-to-pack-ship",
      children: [{ path: "/how-to-pack-ship", name: "HowToPackShip", component: HowToPackShip }],
    },
    {
      path: "/sign-up",
      children: [{ path: "/sign-up", name: "SignUp", component: SignUp }],
    },
    {
      path: "/terms",
      children: [{ path: "/terms", name: "Terms", component: Terms }],
    },
    {
      path: "/privacy",
      children: [{ path: "/privacy", name: "Privacy", component: Privacy }],
    },
    {
      path: "/collection-estimate",
      children: [{ path: "/collection-estimate", name: "CollectionEstimate", component: CollectionEstimate }],
    },
    {
      path: "/:pathMatch(.*)*",
      name: "404",
      component: NotFound,
    },
  ],
});

export default router;
